import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Card, Spinner, Alert } from 'react-bootstrap';
import { useSocket } from "../../../game/socketContext.tsx";
import { DeckData } from '../../../paths/decks/decks.tsx';
import { api } from '../../../index.tsx';

export default function WaitingForGame() {
    const navigate = useNavigate();
    const { deckId } = useParams<{ deckId: string }>();
    const [errorMsg, setErrorMsg] = useState<string | null>(null);
    const [deckList, setDeckList] = useState<DeckData[]>([]);

    const onmessage = useCallback((msg: MessageEvent) => {
        const data = JSON.parse(msg.data);
        console.log(data);

        if (data.action === 'start' || data.action === 'redirect' && data.to === '/games/play') {
            navigate('/games/play');
        } else if (data.action === 'waiting') {
        } else if (data.action === 'return') {
            navigate(data.to || '/games');
        } else if (data.message) {
            setErrorMsg(data.message);
        }
    }, [navigate]);

    const init = useCallback((ws: WebSocket) => {
        ws.send(JSON.stringify({ action: 'joinWaiting', deckId }));
        console.log("joinWaiting");
    }, [deckId]);

    const ws = useSocket(onmessage, init);

    const getDeckList = useCallback(async () => {
        await api
            .post('/decks/get', {}, { withCredentials: true })
            .then((res) => {
                setDeckList(res.data);
            })
            .catch(() => {
                window.location.href = '/logout';
            })
    }, []);

    const asyncEff = useCallback(async () => {
        await getDeckList();
    }, [getDeckList]);

    useEffect(() => { asyncEff(); }, [ws, asyncEff]);

    const deckdata = deckList.find(deck => deck.deck_id === Number(deckId));

    return (
        <Container
            fluid
            className="d-flex flex-grow-1 justify-content-center align-items-center"
            style={{ minHeight: 0 }} // Ensure it doesn't overflow parent flex container
        >
            <Card
                className="text-center shadow-lg p-4"
                style={{ maxWidth: '400px', width: '100%' }}
            >
                <Card.Body>
                    <Spinner
                        animation="border"
                        role="status"
                        className="mb-3 text-primary"
                    >
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                    <Card.Title as="h2" className="mb-3">
                        Waiting for Opponent...
                    </Card.Title>
                    {errorMsg ? <Card.Text className="text-muted mb-4">Error: {errorMsg}</Card.Text> : <Card.Text className="text-muted mb-4">
                        We're searching for an available player to join your game. Please
                        wait.
                    </Card.Text>}
                    {deckId ? (
                        <Alert variant="info" className="mb-0">
                            Selected Deck ID:{' '}
                            <strong>{deckdata ? deckdata.deck_name : 'loading'}</strong>
                        </Alert>
                    ) : (
                        <Alert variant="warning" className="mb-0">
                            No deck selected. Please go back and choose a deck.
                        </Alert>
                    )}
                </Card.Body>
                <Card.Footer className="text-muted bg-light py-3">
                    Do not close or refresh this page.
                </Card.Footer>
            </Card>
        </Container>
    );
}